// extracted by mini-css-extract-plugin
export var container = "_3b-0";
export var error = "_3b-9";
export var label = "_3b-5";
export var light = "_3b-6";
export var md = "_3b-3";
export var sm = "_3b-2";
export var thin = "_3b-8";
export var thinBold = "_3b-7";
export var vertical = "_3b-4";
export var xs = "_3b-1";